export default {"src":"/evde-internet/_next/static/media/modem-yeni-banner-mobile.5ea3cf0f.svg","height":240,"width":360};